import { useState } from "react";
import SelectPrebackorderDateModel from "./PreBackorderDateSelectionModel";
import PreBackorderDomainInputModel from "./PreBackorderDomainsInputModel";

type PreBackorderProps = {
    openPreBackorder: boolean;
    setOpenPreBackorder: React.Dispatch<React.SetStateAction<boolean>>;
    setReloadData: React.Dispatch<React.SetStateAction<number>>;
};

export type Order = {
    domainName: string;
    priority: number;
};

export type OrderResponse = {
    domain: string;
    success: boolean;
    reason: string;
};

export type DropScheduleRecord = {
    dropTimeMS: number;
    fee: number;
    isValid: boolean;
    invalidReason: string;
};

export enum PreBackorderStatus {
    AVAILABLE = "Available",
    DROP_DETAILS_NOT_FOUND = "Domain Drop Details Not Found",
    NOT_SUPPORTED_TLD = "Not Supported TLD",
    FETCH_FAILED = "Schedule Request Failed",
    NOT_AVAILABLE_FOR_PRE_BACKORDER = "Domain is Not Avaliable for Pre Backordering",
}

export type PreBackorderCheckResponse = {
    status: PreBackorderStatus;
    schedule: DropScheduleRecord[];
};

export default function PreBackorderModel(props: PreBackorderProps) {
    const { openPreBackorder, setOpenPreBackorder, setReloadData } = props;

    const [isDateSelectOpen, setIsDateSelectOpen] = useState<boolean>(false);
    const [orderDomain, setOrderDomain] = useState<Order[]>([]);
    const [schedule, setSchedule] = useState<DropScheduleRecord[]>([]);

    if (isDateSelectOpen) {
        return (
            <SelectPrebackorderDateModel
                isOpen={isDateSelectOpen}
                domain={orderDomain}
                schedule={schedule}
                setIsOpen={setIsDateSelectOpen}
                setReloadData={setReloadData}
            />
        );
    }

    return (
        <PreBackorderDomainInputModel
            open={openPreBackorder}
            setOpen={setOpenPreBackorder}
            setDomain={setOrderDomain}
            setSchedule={setSchedule}
            setIsDateSelectOpen={setIsDateSelectOpen}
        />
    );
}
